module.exports = __webpack_public_path__ + "static/media/upperLevel.7b5668ec.jpg";